import VisitFilter from './visits-table-title-filter-layout/visit-filter/VisitFilter'
import StatusFilter from './visits-table-title-filter-layout/status-filter/StatusFilter'
import { VisitsDateFilter } from './visits-date-filter/VisitsDateFilter'
import { visitsListModes, visitTableTitles } from '../../utils/constants'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { getVisitSearchParams } from './VisitTools'
import TagsFilter from './visits-table-title-filter-layout/tags-filter/TagsFilter'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getVisitsConfig = (visitsMode) => {
  const config = [
    {
      title: visitTableTitles.BOOKING_ID,
      value: 'bookingId',
      width: '168px',
    },
    {
      title: visitTableTitles.DATE,
      value: 'date',
      width: '200px',
      hasFilter: true,
      filterSvgIcon: 'filter',
      VisitsFilter: VisitsDateFilter,
      isFilterActive: false,
    },
    { title: visitTableTitles.SCHEDULED_ON, value: 'scheduledOn', isFilterActive: false, width: '168px' },
    {
      title: visitTableTitles.VISIT,
      value: 'visit',
      withTooltip: true,
      isFilterActive: false,
      isShowFilterComponent: false,
      FilterComponent: VisitFilter,
      width: '193px',
    },
    {
      title: visitTableTitles.PROVIDER,
      value: 'provider',
      withTooltip: true,
      isFilterActive: false,
      width: '214px',
    },
    {
      title: visitTableTitles.PATIENT,
      value: 'patient',
      withTooltip: true,
      isFilterActive: false,
      width: '263px',
    },
    {
      title: visitTableTitles.TAGS,
      value: 'tags',
      withTooltip: true,
      FilterComponent: TagsFilter,
      isFilterActive: false,
      width: '250px',
    },
    {
      title: visitTableTitles.STATUS,
      className: visitsMode === visitsListModes.PAST_MODE ? 'visit-status-section-past ' : 'visit-status-section',
      value: 'status',
      withTooltip: true,
      isFilterActive: false,
      isShowFilterComponent: false,
      FilterComponent: StatusFilter,
      width: visitsMode === visitsListModes.PAST_MODE ? '207px' : '305px',
    },
    {
      title: visitTableTitles.PAYMENT_ID,
      value: 'paymentId',
      withTooltip: true,
      width: '171px',
    },
    {
      title: visitTableTitles.REMARKS,
      value: 'remarks',
      width: '132px',
      align: 'center',
      isFilterActive: false,
    },
  ]

  if (visitsMode === visitsListModes.PAST_MODE) {
    return config.filter((item) => item.title !== visitTableTitles.TAGS)
  }

  return config
}
